import {
  createStyles,
  Title,
  Text,
  Space,
  Anchor,
  Image,
  Box,
  Divider,
} from '@mantine/core';
import { themeColors } from '../../config/themeSettings';

const IndiatodayTraffickingBust = () => {
  const { classes } = useStyles();

  return (
    <div>
      <div className={classes.dateCategory}>
        November 06, 2025 | India News
      </div>
      <section className={classes.header}>
        <Title order={1} className={classes.title}>
          AI-based safety app helps bust immoral trafficking racket at Delhi spa, 6 rescued
        </Title>
      </section>
      <div className={classes.container}>
        <Box className={classes.sectionCenter}>
          <Image src="https://akm-img-a-in.tosshub.com/indiatoday/images/story/202511/delhi-spa-operating-immoral-trafficking-065954438-16x9_0.png?VersionId=9l2bX9cX9fjp9jSUXYwVp_VPdFWjHHdX&size=690:388" />
          <div className={classes.imageAttribution}>
            Image from India Today
          </div>

          <section className={classes.paragraph}>
            <Space h="md" />
            <Text>
              Delhi police busted a human trafficking racket operating under the guise of a spa in Paharganj. The operation was aided by the AI-enabled Say Help app, highlighting tech's role in combating gender-based crimes.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Major Breakthrough
            </Title>
            <Space h="md" />
            <Text>
              In a major breakthrough against human trafficking and exploitation, Delhi police busted an immoral trafficking racket operating under the guise of a spa in the Paharganj area. The swift operation followed an alert received through the AI-enabled "Say Help" safety application, leading to the rescue of six women and the arrest of one accused.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              The Alert and Response
            </Title>
            <Space h="md" />
            <Text>
              On the intervening night of October 30 and 31, an alert about suspected immoral activities was received through the Say Help app from the Paharganj locality. Acting promptly, a joint team comprising members of the Special Staff, Central District, and representatives of the Say Help app initiated verification and surveillance.
            </Text>
            <Space h="md" />
          </section>
          <Divider></Divider>
          <Text className={classes.footNote}>
            Story by{' '}
            <Anchor href="https://www.indiatoday.in/author/arvind-ojha" target="_blank">
              Arvind Ojha
            </Anchor>
            ,{' '}
            <Anchor href="https://www.indiatoday.in/author/himanshu-mishra" target="_blank">
              Himanshu Mishra
            </Anchor>
            . Edited by{' '}
            <Anchor href="https://www.indiatoday.in/author/harshita-das" target="_blank">
              Harshita Das
            </Anchor>
            . Source:{' '}
            <Anchor href="https://www.indiatoday.in/cities/delhi/story/ai-based-safety-app-helps-bust-immoral-trafficking-racket-at-delhi-spa-6-rescued-2814618-2025-11-06" target="_blank">
              India Today
            </Anchor>
          </Text>
        </Box>
      </div>
    </div>
  );
};

export default IndiatodayTraffickingBust;

const useStyles = createStyles(theme => ({
  root: {
    fontFamily: 'Poppins',
    backgroundColor: themeColors.white,
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
  },

  dateCategory: {
    fontSize: 14,
    fontWeight: 'normal',
    marginBottom: 10,
    textAlign: 'center',
    color: '#757575',
  },

  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },

  header: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 900px)',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,
  },

  footNote: {
    fontSize: 12,
    marginTop: 20,
    color: '#757575',
  },

  imageAttribution: {
    fontSize: 12,
    marginTop: 10,
    color: '#757575',
  },

  title: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  titleLeft: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  paragraph: {
    fontFamily: 'Poppins',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 900,
  },
}));
